import { getLocationSearchToObject } from '../utils/format';

export default class CustomersLogin {
  constructor() {
    const params = getLocationSearchToObject();
    if (params && params.email) {
      const input = document.getElementById('RecoverEmail');
      input.value = params.email;
    }
  }
}
